  import React, { useState } from 'react';
  import emailjs from 'emailjs-com';
  import './ContactForm.css';
  import Salutation from './Salutation';
  import NameFields from './NameFields';
  import AddressFields from './AddressFields';
  import ContactInfo from './ContactInfo';
  import DetailsField from './DetailsField';
  import SolarCalculator from './SolarCalculator';

  const ContactForm = () => {
    const [formData, setFormData] = useState({
      salutation: 'Mr',
      firstName: '',
      lastName: '',
      street: '',
      houseNumber: '',
      city: '',
      postalCode: '',
      phone: '',
      email: '',
      details: '',
      selectedLoads: [],
    });

    const [showCalculator, setShowCalculator] = useState(false);

    const handleInputChange = (e) => {
      const { name, value, type, checked } = e.target;

      if (type === "checkbox") {
        setFormData((prevData) => {
          const newValues = checked
            ? [...prevData[name], value]
            : prevData[name].filter((v) => v !== value);
          return { ...prevData, [name]: newValues };
        });
      } else {
        setFormData({ ...formData, [name]: value });
      }
    };

    const toggleCalculator = () => {
      setShowCalculator(!showCalculator);
    };

    const validateForm = () => {
      if (formData.phone.trim() === '' && formData.email.trim() === '') {
        alert('Bitte geben Sie entweder eine Telefonnummer oder eine E-Mail-Adresse ein.');
        return false;
      }
      return true;
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      // Send Email via EmailJS
      try {
        const emailResponse = await emailjs.send(
          'YOUR_SERVICE_ID',
          'YOUR_TEMPLATE_ID',
          {
            salutation: formData.salutation,
            firstName: formData.firstName,
            lastName: formData.lastName,
            street: formData.street,
            houseNumber: formData.houseNumber,
            city: formData.city,
            postalCode: formData.postalCode,
            phone: formData.phone,
            email: formData.email,
            details: formData.details,
            selectedLoads: formData.selectedLoads.join(', '), // Converts array to string
          },
          'YOUR_USER_ID'
        );
        console.log('Email Sent:', emailResponse.text);
      } catch (error) {
        console.error('Failed to send email:', error);
        alert('Failed to send email.');
        return;
      }
    
      // Post data to Google Sheets via Google Apps Script
      try {
        const sheetResponse = await fetch('YOUR_GOOGLE_SCRIPT_URL', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });
    
        if (sheetResponse.ok) {
          console.log('Data posted to Google Sheets');
          alert('Form submitted successfully!');
        } else {
          console.error('Failed to post data to Google Sheets');
          alert('Failed to submit form data to Google Sheets.');
        }
      } catch (error) {
        console.error('Error posting to Google Sheets:', error);
        alert('Failed to submit form data to Google Sheets.');
      }
    };
    

    return (
      <div className="container">
        <h1>Kontaktiere uns</h1>
        <p className="subtitle">Kontaktformular damit wir uns bei dir melden können</p>
        
        <form id="contact-form" onSubmit={handleSubmit}>
          <Salutation formData={formData} handleInputChange={handleInputChange} />
          <NameFields formData={formData} handleInputChange={handleInputChange} />
          <AddressFields formData={formData} handleInputChange={handleInputChange} />
          <ContactInfo formData={formData} handleInputChange={handleInputChange} />

          {/* Toggle for Solar Calculator */}
          <div className="form-group">
            <label>
              <input type="checkbox" onChange={toggleCalculator} /> Solar Präferenzen hinzufügen
            </label>
          </div>

          {/* Conditional rendering of Solar Calculator */}
          {showCalculator && <SolarCalculator formData={formData} handleInputChange={handleInputChange} />}
          
          <DetailsField formData={formData} handleInputChange={handleInputChange} />

          <button type="submit" className="submit-btn">Absenden</button>
        </form>
      </div>
    );
  };

  export default ContactForm;
